export const newcustomerState = {
  customerCategory: "",
  customerCode: "",
  customerName: "",
  customeraddress: "",
  date: "",
  priceCode: "",
  number: "",
  email: "",
  // status
  customerCategoryStatus: "unchecked",
  customerCodeStatus: "unchecked",
  customerNameStatus: "unchecked",
  customeraddressStatus: "unchecked",
  dateStatus: "unchecked",
  priceCodeStatus: "unchecked",
  numberStatus: "unchecked",
  emailStatus: "unchecked",
};

export const newCustomerStateMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "customerCategory": {
      if (value) {
        return {
          ...state,
          customerCategory: value,
          customerCategoryStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          customerCategory: "",
          customerCategoryStatus: "unchecked",
        };
      }
    }
    case "priceCode": {
      if (value) {
        return {
          ...state,
          priceCode: value,
          priceCodeStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          priceCode: "",
          priceCodeStatus: "unchecked",
        };
      }
    }
    case "customerCode": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          customerCode: value,
          customerCodeStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          customerCode: "",
          customerCodeStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          customerCode: value,
          customerCodeStatus: "error",
        };
      }
    }
    case "customerName": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          customerName: value,
          customerNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          customerName: "",
          customerNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          customerName: value,
          customerNameStatus: "error",
        };
      }
    }
    case "customeraddress": {
     const alphaNLenghthRegex = new RegExp("^.{1,10000}$", "s");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          customeraddress: value,
          customeraddressStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          customeraddress: "",
          customeraddressStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          customeraddress: value,
          customeraddressStatus: "error",
        };
      }
    }
    case "number": {
      const cleanedValue = value.replace(/[^\d]/g, ""); // remove non-digits for length check
      // const isValidLength = cleanedValue.length >= 8 && cleanedValue.length <= 10;
      const isValidLength = cleanedValue.length == 8;
      const validCharRegex = /^[0-9+\s()]*$/; // only allows digits, +, (, ), space

      if (validCharRegex.test(value) && isValidLength) {
        return {
          ...state,
          number: value,
          numberStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          number: "",
          numberStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          number: value,
          numberStatus: "error",
        };
      }
    }

    case "email": {
      const emailRegex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g);
      if (emailRegex.test(value)) {
        return {
          ...state,
          email: value,
          emailStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          email: "",
          emailStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          email: value,
          emailStatus: "error",
        };
      }
    }
    case "date": {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/; // Regex for the format YYYY-MM-DD
      if (value && dateRegex.test(value)) {
        return {
          ...state,
          date: value,
          dateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          date: "",
          dateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          date: value,
          dateStatus: "error",
        };
      }
    }
    case "fromDate": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          fromDate: value,
          fromDateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          fromDate: "",
          fromDateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          fromDate: value,
          fromDateStatus: "error",
        };
      }
    }
    case "toDate": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100000})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          toDate: value,
          toDateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          toDate: "",
          toDateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          toDate: value,
          toDateStatus: "error",
        };
      }
    }
    default:
      return state;
  }
};
